import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PortalAuthLayout from "./PortalAuthLayout";

const PortalLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // { text, code } — code dari server menentukan apakah ada tindak lanjut
  // yang ditawarkan (mis. membuat password).
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const toPassword = (mode) =>
    navigate(`/portal/password?mode=${mode}${email ? `&email=${encodeURIComponent(email)}` : ""}`);

  const login = async (e) => {
    e.preventDefault();
    if (!email || !password) return setError({ text: "Please input your email and password." });
    setIsLoading(true);
    try {
      await axios.post("/studentportal/login", { email, password });
      navigate("/portal/dashboard");
    } catch (err) {
      setError({
        text: err.response?.data?.msg || "Unable to log in. Please try again.",
        code: err.response?.data?.code,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PortalAuthLayout>
      <h1 className="sp-auth-title">Welcome Back</h1>
      <p className="sp-auth-subtitle">Sign in to your Student Portal</p>

      {error && (
        <div className="sp-auth-note is-error" role="alert">
          {error.text}
          {error.code === "PASSWORD_NOT_SET" && (
            <button type="button" className="sp-link" onClick={() => toPassword("create")}>
              Create your password now
            </button>
          )}
        </div>
      )}

      <form onSubmit={login} noValidate>
        <div className="sp-field">
          <label htmlFor="sp-email">Email address</label>
          <input
            id="sp-email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="sp-field">
          <label htmlFor="sp-password">Password</label>
          <input
            id="sp-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="sp-auth-row">
          <button type="button" className="sp-link" onClick={() => toPassword("forgot")}>
            Forgot password?
          </button>
        </div>
        <button type="submit" className="sp-btn" disabled={isLoading}>
          {isLoading ? "Signing in..." : "Login"}
        </button>
      </form>

      <p className="sp-auth-foot">
        First time here?{" "}
        <button type="button" className="sp-link" onClick={() => toPassword("create")}>
          Create your password
        </button>
      </p>
    </PortalAuthLayout>
  );
};

export default PortalLogin;
